import { useQuery } from '@tanstack/react-query'

import { transferServices } from '../transferServices'
import { QUERY_KEYS } from '@/constants/queryKeys'

export const useFetchSavingGoals = () =>
  useQuery({
    queryKey: [QUERY_KEYS.SAVING_GOALS],
    queryFn: transferServices.fetchSavingGoals,
    staleTime: 60 * 5 * 1000,
  })
